<div id="contact" class="">
    <div class="container content-section">
        <h3 class="h3">Thông tin liên hệ</h3>
        <!-- /.row -->
        <div class="row">
            <div class="col-md-offset-2 col-md-8 text-center bigger-text">
                <p>Quisque egestas, dui accumsan bibendum semper, eros metus iaculis orci, in fermentum sapien magna quis turpis. Vestibulum ante ipsum primis.</p>
            </div>
            <div class="col-md-6 col-sm-6">
                <div id="map">
                </div>
            </div>
            <!-- /.col-md-6 -->
            <div class="col-md-6 col-sm-6">

                <div class="row contact-form">

                    <fieldset class="col-md-6 col-sm-6">
                        <input id="name" type="text" name="name" placeholder="Họ tên">
                    </fieldset>
                    <fieldset class="col-md-6 col-sm-6">
                        <input type="email" name="email" id="email" placeholder="Email">
                    </fieldset>
                    <fieldset class="col-md-12">
                        <input type="text" name="subject" id="subject" placeholder="Chủ đề">
                    </fieldset>
                    <fieldset class="col-md-12">
                        <textarea name="comments" id="comments" placeholder="Tin nhắn"></textarea>
                    </fieldset>
                    <fieldset class="col-md-12">
                        <input type="submit" name="send" onclick="submitForm()" value="Send Message" id="submit" class="button">
                    </fieldset>

                </div>
                <!-- /.contact-form -->

            </div>
            <!-- /.col-md-6 -->
        </div>
        <!-- /.row -->
    </div>
    <!-- /.container -->
</div>
<!-- /#products -->